module.exports = __webpack_public_path__ + "static/adventist-logo-07db215441c42c58142086ed27901f42.svg";